import React from "react";

const Modal = ({ isOpen, onClose, title, message, type = "success", dir = "ltr" }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      dir={dir}
    >
      <div className="w-full max-w-md rounded-lg bg-white p-6 text-center shadow-lg">
        <h2
          className={`mb-4 text-2xl font-bold ${
            type === "success" ? "text-green-600" : "text-red-600"
          }`}
        >
          {title}
        </h2>
        <p className="mb-6 text-gray-700">{message}</p>
        <button
          onClick={onClose}
          className="rounded-md bg-[#a91079] px-6 py-2 text-white hover:bg-[#a91079e2]"
        >
          {dir === "rtl" ? "حسناً" : "OK"}
        </button>
      </div>
    </div>
  );
};

export default Modal; 